export default
    {
        path:'/elective',
        name:'新高考选科',
        redirect:'/elective/main',
        component:()=>import('../views/elective/index'),
        meta:{requireAuth:true,roles:['student']},
        children:[
            {
                path:'/elective/main',
                name:'新高考选科主页',
                component:()=>import('../views/elective/main'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path: '/elective/xuekezhixuan',
                component: () => import('../views/elective/xuankeyaoqiuchaxun/xuekezhixuan') ,
                children:[
                    {
                        path: '/elective/xuekezhixuan/university',
                        name:'按大学查询',
                        component:() => import('../views/elective/xuankeyaoqiuchaxun/university'),
                        meta:{requireAuth:true,roles:['student']},
                    },
                    {
                        path: '/elective/xuekezhixuan/subject',
                        name:'/按科目查询',
                        component:() => import('../views/elective/xuankeyaoqiuchaxun/subject'),
                        meta:{requireAuth:true,roles:['student']},
                    }
                ]
            },
            {
                path: '/elective/majorSelectedSubjects',
                component: () => import('../views/elective/majorSelectedSubjects/majorSelectedSubjects') ,
                children:[
                    {
                        path: '/elective/majorSelectedSubjects/mubiaozhuanye',
                        name:'设置目标专业',
                        component:() => import('../views/elective/majorSelectedSubjects/components/mubiaozhuanye'),
                        meta:{requireAuth:true,roles:['student']},
                    },
                    {
                        path: '/elective/majorSelectedSubjects/xuekeyaoqiu',
                        name:'目标专业学科要求',
                        component:() => import('../views/elective/majorSelectedSubjects/components/xuekeyaoqiu'),
                        meta:{requireAuth:true,roles:['student']},
                    },
                    {
                        path: '/elective/majorSelectedSubjects/xuankeyuanxiao',
                        name:'选科院校',
                        component:() => import('../views/elective/majorSelectedSubjects/components/xuankeyuanxiao'),
                        meta:{requireAuth:true,roles:['student']},
                    },
                    {
                        path: '/elective/majorSelectedSubjects/xuekeyaoqiushezhi',
                        name:'/目标专业学科要求设置',
                        component:() => import('../views/elective/majorSelectedSubjects/components/xuekeyaoqiushezhi'),
                        meta:{requireAuth:true,roles:['student']},
                    },
                    {
                        path: '/elective/majorSelectedSubjects/pinghengdan1',
                        name:'/填写平衡单1',
                        component:() => import('../views/elective/majorSelectedSubjects/components/pinghengdan1'),
                        meta:{requireAuth:true,roles:['student']},
                    },
                    {
                        path: '/elective/majorSelectedSubjects/pinghengdan2',
                        name:'/填写平衡单2',
                        component:() => import('../views/elective/majorSelectedSubjects/components/pinghengdan2'),
                        meta:{requireAuth:true,roles:['student']},
                    },
                    {
                        path: '/elective/majorSelectedSubjects/xuankezhiyuan',
                        name:'/设置选科志愿',
                        component:() => import('../views/elective/majorSelectedSubjects/components/xuankezhiyuan'),
                        meta:{requireAuth:true,roles:['student']},
                    },
                    {
                        path: '/elective/majorSelectedSubjects/xuankeReport',
                        name:'/选科报告',
                        component:() => import('../views/elective/majorSelectedSubjects/components/xuankeReport'),
                        meta:{requireAuth:true,roles:['student']},
                    }
                ]
            },
        ]
    }
